import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import './plugins/editor.js'
import router from './router'  // 路由管理
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store/index'  // 状态管理
import config from './config/default';  // 全局配置信息

Vue.config.productionTip = false
Vue.use(VueAxios, axios)

Vue.prototype.baseUrl = config.baseUrl;  // 请求路径
Vue.prototype.imgUrl = config.baseUrl + '/uploadFiles/';  // 图片路径
Vue.prototype.uploadAction = config.baseUrl + "/admin/Image/uploadImage";  // 图片上传
Vue.prototype.uploadAccept = ".jpeg, .png, .jpg, .gif";  // 图片上传

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
